var _filter, _circle, _circle2, _circle3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "rgba(0, 0, 127, 1)",
    cx: 256,
    cy: 256,
    r: 224,
    filter: "url(#shadow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "rgba(0, 0, 255, 1)",
    cx: 256,
    cy: 256,
    r: 180
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "rgba(0, 0, 127, 1)",
    cx: 256,
    cy: 256,
    r: 140
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0, 0, 127, 1)",
    d: "M 128 128                L 384 384                M 128 384                L 384 128",
    strokeWidth: 20
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTower);
export default __webpack_public_path__ + "static/media/tower.0f93f96cf21ba6a2ab0d1f4af6a56a0c.svg";
export { ForwardRef as ReactComponent };